import moment from 'moment';
import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, switchMap, catchError } from 'rxjs';
import {AppConfig} from '../../app.config';
moment.locale('de');
@Injectable()
export class EventService  {
  events: any[];
  relisedEvents: any[];
  countryId = '';
  citiesId = [];
  organizationonsId = [];
  eventRegistration: any = '';
  publicEvents: any = '';
  milestone: any = '';
  migrate: any = '';
  myEvents: any = '';
  targetGroups = [];
  eventTypes = [];
  onEventChanged: BehaviorSubject<any> = new BehaviorSubject({});
  onEventRelisedChanged: BehaviorSubject<any> = new BehaviorSubject({});

  constructor (private http: HttpClient , private api: AppConfig) {

  }

  getReleased () {
    return new Promise((resolve , reject) => {
      this.http.get(this.api.baseUrl + '/event/eventReleased' , this.api.jsonTokenHeaders).subscribe((response: any) => {
        for (let i = 0; i < response.length; i++) {
          let _dates = '';
          let dateForSort = '2222/01/01';
          if (response[ i ]?.eventDates?.length) {
            let divider = ', ';
            if (response[ i ].datesType === 'oneDay') {
              divider = '';
            }
            if (response[ i ].datesType === 'longEvent') {
              divider = ' - ';
            }
            if (response[ i ].datesType === 'fewDays') {
              divider = '/ ';
            }
            if (response[ i ].datesType === 'repeatEvent') {
              divider = ', ';
            }

            let _data = response[ i ].eventDates;

            if (_data.length) {
              dateForSort = moment(_data[ 0 ].date).format('YYYY/MM/DD');
            }


            _data.forEach(el => {
              if (_dates) {
                _dates =
                  _dates +
                  divider +
                  moment(el.date).format('dddd, DD. MMMM YYYY');
              } else {
                _dates = moment(el.date).format('dddd, DD. MMMM YYYY');
              }
            });
          }
          response[ i ].dateForShow = _dates;
          response[ i ].dateForSort = dateForSort;
          if (new Date(dateForSort).setHours(0 , 0 , 0 , 0) === new Date().setHours(0 , 0 , 0 , 0)) {
            response[ i ].dayColor = '#f2f30f7a';
            response[ i ].dateForSort = '3333/01/01';
          }
          if (new Date(dateForSort).setHours(0 , 0 , 0 , 0) > new Date().setHours(0 , 0 , 0 , 0)) {
            response[ i ].dayColor = '#00800012';
          }
          if (new Date(dateForSort).setHours(0 , 0 , 0 , 0) < new Date().setHours(0 , 0 , 0 , 0)) {
            response[ i ].dayColor = '#ff000014';
          }
        }
        if (response.length) {
          this.relisedEvents = response.sort((a , b) => {
            return ((new Date(b.dateForSort)).getTime() - (new Date(a.dateForSort)).getTime());
          });
        } else {
          this.relisedEvents = [];
        }
        this.onEventRelisedChanged.next(this.relisedEvents);
        resolve(response);
      } , reject);
    });
  }

  getEventsForLearningPaths(organizationId) {
    return this.http.get(this.api.baseUrl + '/event/eventsForLearningPaths?organizationId=' + organizationId, this.api.jsonTokenHeaders);
  }

  getSubEventForBooking(eventId) {
    return this.http.get(this.api.baseUrl + '/subEvent/subEventForBooking?eventId=' + eventId, this.api.jsonTokenHeaders);
  }

  editSubEventBooking(data) {
    return this.http.post(this.api.baseUrl + '/subEventBooking/editSubEventBooking', data, this.api.formDataHeaders);
  }

  removeSubEventBookingByAdmin(data) {
    return this.http.post(this.api.baseUrl + '/subEventBooking/removeSubEventBookingByAdmin', data, this.api.formDataHeaders);
  }

  finishBooking(eventId) {
    return this.http.get(this.api.baseUrl + '/event/finishBooking?eventId=' + eventId, this.api.jsonTokenHeaders);
  }

  sendNotification(eventId) {
    return this.http.get(this.api.baseUrl + '/subEvent/sendNotification?eventId=' + eventId, this.api.jsonTokenHeaders);
  }

  setCountryId (id) {
    this.countryId = id;
    this.citiesId = [];
    this.organizationonsId = [];
  }

  setCities (city) {
    if (city.selected) {
      this.citiesId.push(city.canton);
    } else {
      const index = this.citiesId.indexOf(city.canton);
      if (index !== -1) {
        this.citiesId.splice(index , 1);
      }
    }
  }

  setCity (city) {
    this.citiesId = [];
    this.citiesId.push(city);
  }

  setOrganizations (organization) {
    if (organization.selected) {
      this.organizationonsId.push(organization.organization);
    } else {
      const index = this.organizationonsId.indexOf(organization.organization);
      if (index !== -1) {
        this.organizationonsId.splice(index , 1);
      }
    }
  }

  setOrganization (organization) {
    this.organizationonsId = [];
    this.organizationonsId.push(organization);
  }

  setToAll () {
    this.countryId = '';
    this.citiesId = [];
    this.targetGroups = [];
    this.organizationonsId = [];
    this.eventTypes = [];
    this.milestone = '';
    this.publicEvents = '';
    this.myEvents = '';
    this.migrate = '';
    this.eventRegistration = '';
  }

  getOrganizationByCantons () {
    return this.http.get(this.api.baseUrl + '/organization/organizationByCantons?cantons=' + this.citiesId.toString() , this.api.jsonTokenHeaders);
  }

  getQrcode (eventId) {
    return this.http.get(this.api.baseUrl + '/code/qrCodes?eventId=' + eventId , this.api.jsonTokenHeaders);
  }

  subscriptionToEvent (body) {
    return this.http.post(this.api.baseUrl + '/subscription/addSubscription' , body , this.api.formDataHeaders);
  }

  deleteFromParticipant (id, isFront) {
    return this.http.get(this.api.baseUrl + '/participant/deleteParticipant?id=' + id + '&isFront=' + isFront , this.api.formDataHeaders);
  }

  moveFromWaitingLisr (body) {
    return this.http.post(this.api.baseUrl + '/participant/addParticipant' , body , this.api.formDataHeaders);
  }

  getEventsBudget(id?) {
    if (this.organizationonsId.toString()) {
      return this.http.get(this.api.baseUrl + '/event/eventsBudget?organizationId=' + this.organizationonsId.toString(),
        this.api.formDataHeaders);
    } else if (id) {
      return this.http.get(this.api.baseUrl + '/event/eventsBudget?organizationId=' + id,
        this.api.formDataHeaders);
    }
  }

  getEventsTimes(id?) {
    if (this.organizationonsId.toString()) {
      return this.http.get(this.api.baseUrl + '/event/eventsTime?organizationId=' + this.organizationonsId.toString(),
        this.api.formDataHeaders);
    } else if (id) {
      return this.http.get(this.api.baseUrl + '/event/eventsTime?organizationId=' + id,
        this.api.formDataHeaders);
    }
  }

  getRowsForGuestEvent() {
    return this.http.get(this.api.baseUrl + '/guestsInfoRows/getTableInfo', this.api.formDataHeaders);
  }

  getGuestUserData(id, isFront, eventId) {
    return this.http.get(this.api.baseUrl + '/guestData/getGuestUserData?id=' + id + '&isFront=' + isFront +
      '&eventId=' + eventId, this.api.formDataHeaders);
  }

  getAllGuestUserData(eventId) {
    return this.http.get(this.api.baseUrl + '/guestData/getAllGuestUserData?eventId=' + eventId, this.api.formDataHeaders);
  }

  getAdditionalData(id, eventId) {
    return this.http.post(this.api.baseUrl + '/additionalData/getAdditionalData', {type: 'back', token: id, eventId: eventId});
  }

  getAllAdditionalData(ids, eventId) {
    return this.http.post(this.api.baseUrl + '/additionalData/getAllAdditionalData', {ids: ids, eventId: eventId});
  }

  getTableInfoById(ids) {
    return this.http.get(
      this.api.baseUrl + '/guestsInfoRows/getTableInfoById?ids=' + ids
    );
  }

  guestUsers(body) {
    return this.http.post(this.api.baseUrl + '/guestUsers/addGuestUsers', body);
  }

  guestData(body) {
    return this.http.post(this.api.baseUrl + '/guestData/addGuestUsersData', body);
  }

  addAdditionalData(body) {
    return this.http.post(
      this.api.baseUrl + '/additionalData/addAdditionalData',
      body
    );
  }

  getEventOrganization(eventId, orgId) {
    return this.http.get(this.api.baseUrl +
      '/organization/getEventOrganization?eventId=' +
      eventId +
      '&orgId=' +
      orgId
    );
  }

  getFileStream(name) {
    if (name) {
      return this.api.baseUrl + '/event/getEventFilesStream/' + name;
    } else {
      return '';
    }
  }

  getImageAsBase64(imageUrl: string): Observable<string> {
    return this.http.get(imageUrl, { responseType: 'blob' }).pipe(
      switchMap(blob => {
        return new Observable<string>(observer => {
          const reader = new FileReader();
          reader.onloadend = () => {
            if (typeof reader.result === 'string') {
              observer.next(reader.result);
            } else {
              observer.error('Unable to convert image to Base64 string.');
            }
            observer.complete();
          };
          reader.onerror = (error) => {
            observer.error('File reading error: ' + error);
          };
          reader.readAsDataURL(blob);
        });
      }),
      catchError(error => {
        console.error('Error loading or encoding image:', error);
        throw new Error('Failed to retrieve or encode image.');
      })
    );
  }
}

